import { flatten, compact } from 'lodash';

export const generateEdges = (list) => {
  /*
    Returns all possible pair variations.
    eg.
    Input: ['a', 'b', 'c', 'd']
    Output: [
      ['a', 'b'],
      ['a', 'c'],
      ['a', 'd'],
      ['b', 'c'],
      ['b', 'd'],
      ['c', 'd'],
    ]
  */
  const result = list.map((item, idx) => {
    return list.slice(idx).map(i => {
      if (item === i) return null;
      return [item, i];
    })
  });

  return compact(flatten(result));
};
